// extracted by mini-css-extract-plugin
export default {"round":"CheckBoxV2_round__ut8dj","container":"CheckBoxV2_container__7V2+x"};